import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { LimitItem } from '@shared/models';
import { TransactionLimitItemComponent } from '../transaction-limit-item/transaction-limit-item.component';

@Component({
  selector: 'app-transaction-limits',
  templateUrl: './transaction-limits.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RktIconComponent, TransactionLimitItemComponent],
})
export class TransactionLimitsComponent {
  isEditAllowed = input<boolean>(true);

  transactionLimits = input<LimitItem[]>([]);

  editClick = output<void>();
}
